import { render, staticRenderFns } from "./questionList.vue?vue&type=template&id=8b20c048&scoped=true&"
import script from "./questionList.vue?vue&type=script&lang=js&"
export * from "./questionList.vue?vue&type=script&lang=js&"
import style0 from "./questionList.vue?vue&type=style&index=0&id=8b20c048&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b20c048",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\xampp\\htdocs\\SNS_Thai\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8b20c048')) {
      api.createRecord('8b20c048', component.options)
    } else {
      api.reload('8b20c048', component.options)
    }
    module.hot.accept("./questionList.vue?vue&type=template&id=8b20c048&scoped=true&", function () {
      api.rerender('8b20c048', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/social/questionList.vue"
export default component.exports